import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";

// Global Console Interceptor for remote diagnostics
window.__logs = window.__logs || [];
const _log = console.log;
const _warn = console.warn;
const _err = console.error;

console.log = (...args) => {
  window.__logs.push({ type: "log", text: args.map(a => typeof a === "object" ? JSON.stringify(a) : String(a)).join(" ") });
  _log.apply(console, args);
};
console.warn = (...args) => {
  window.__logs.push({ type: "warn", text: args.map(a => typeof a === "object" ? JSON.stringify(a) : String(a)).join(" ") });
  _warn.apply(console, args);
};
console.error = (...args) => {
  window.__logs.push({ type: "error", text: args.map(a => typeof a === "object" ? JSON.stringify(a) : String(a)).join(" ") });
  _err.apply(console, args);
};

window.addEventListener("error", (e) => {
  window.__logs.push({ type: "error", text: `Uncaught Error: ${e.message} at ${e.filename}:${e.lineno}` });
  if (e.message === "ResizeObserver loop limit exceeded" || e.message === "ResizeObserver loop completed with undelivered notifications.") {
    const errOverlay = document.getElementById("webpack-dev-server-client-overlay");
    if (errOverlay) errOverlay.style.display = "none";
  }
});

window.addEventListener("unhandledrejection", (e) => {
  window.__logs.push({ type: "error", text: `Unhandled Promise Rejection: ${e.reason?.message || e.reason}` });
});

// Global Axios Authentication Interceptors
axios.interceptors.request.use((config) => {
  const code = localStorage.getItem("atlas_access_code");
  if (code) {
    config.headers.Authorization = `Bearer ${code}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("atlas_access_code");
      window.dispatchEvent(new Event('atlas-unauthorized'));
    }
    if (error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('atlas-forbidden', { detail: error.response?.data?.detail || "Action not permitted." }));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
